const amountFormatter = new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR' });

export function formatQuoteAmount(amount: number) {
  return amountFormatter.format(amount);
}
